import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import GenderLookupViewModel from '../ViewModels/GenderLookupViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});

interface IGenderIdentityDropDownProps {
    setGenderIdentity?: (event) => void;
    name: string;
    genderIdentity: string | undefined;
    label: string;
    disabled: boolean;
}

interface IGenderIdentityDropDownState {
    model: GenderLookupViewModel[];
    loaded: boolean;
}

class GenderIdentityDropDown extends Component<IGenderIdentityDropDownProps & WithStyles<typeof styles>, IGenderIdentityDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetGenderIdentities').then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key={`${this.props.name}_defaultGenderIdentityVal`} value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={`${this.props.name}_${item.value}`} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label={this.props.label}
                name={this.props.name}
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.genderIdentity}
                onChange={this.props.disabled ? undefined : this.props.setGenderIdentity}
                disabled={this.props.disabled}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(GenderIdentityDropDown);
